







































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { VehicleType, ApiError } from '@/api';
import { snackModule, authModule } from '@/store';
import { Route } from 'vue-router';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';

@Component({
  components: {
    ConfirmDialog,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  vehicleType: VehicleType | null = null;

  nextFn: (() => void) | null = null;
  leaveConfirmDialog: boolean = false;
  confirmLeaveContent: string =
    'Are you sure you would like to leave? Any unsaved changes will be lost.';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  get vehicleTypeId() {
    return this.$route.params.vehicleTypeId;
  }

  back() {
    this.$router.back();
  }

  beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
    if (this.vehicleType && this.vehicleType.isDirty()) {
      this.nextFn = next;
      this.leaveConfirmDialog = true;
      next(false);
    } else {
      next();
    }
  }

  leave() {
    if (this.nextFn) {
      this.nextFn();
    }
  }

  async save() {
    if (!this.vehicleType) {
      return;
    }

    try {
      await this.vehicleType.save();
      if (
        this.$route.name === 'admin-vehicletypes-add' &&
        this.vehicleType &&
        this.vehicleType.id
      ) {
        this.$router.push({
          name: 'admin-vehicletypes-edit',
          params: { vehicleTypeId: this.vehicleType.id },
        });
        snackModule.showSnackbar('VehicleType Created');
      } else {
        snackModule.showSnackbar('VehicleType Updated');
      }
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    if (this.$route.name === 'admin-vehicletypes-edit' && this.vehicleTypeId) {
      try {
        this.vehicleType = (await VehicleType.find(this.vehicleTypeId)).data;
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Vehicle type not found');
      }
    } else {
      this.vehicleType = new VehicleType();
    }
  }
}
